import { render } from "./Facts.vue?vue&type=template&id=093b8a3e"
import script from "./Facts.vue?vue&type=script&lang=js"
export * from "./Facts.vue?vue&type=script&lang=js"
script.render = render

export default script